import MarkdownDocs from 'docs/src/modules/components/MarkdownDocs';
import * as pageProps from 'docs/data/system/screen-readers/screen-readers.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
